import React from 'react';
import Icon from '../../../components/AppIcon';

const ShiftStatistics = () => {
  const stats = [
    {
      id: 1,
      label: "Kommende Schichten",
      value: "18",
      icon: "Calendar",
      color: "text-primary",
      bgColor: "bg-primary/10"
    },
    {
      id: 2,
      label: "Diese Woche",
      value: "5",
      icon: "Clock",
      color: "text-accent",
      bgColor: "bg-accent/10"
    },
    {
      id: 3,
      label: "Überstunden",
      value: "12.5h",
      icon: "TrendingUp",
      color: "text-warning",
      bgColor: "bg-warning/10"
    },
    {
      id: 4,
      label: "Konflikte",
      value: "2",
      icon: "AlertTriangle",
      color: "text-error",
      bgColor: "bg-error/10"
    }
  ];

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-foreground mb-4">Schicht-Statistiken</h3>
      {stats?.map((stat) => (
        <div key={stat?.id} className="bg-card border border-border rounded-lg p-4 shadow-card">
          <div className="flex items-center space-x-3">
            <div className={`w-10 h-10 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
            <div>
              <p className="text-2xl font-bold text-foreground">{stat?.value}</p>
              <p className="text-sm text-muted-foreground">{stat?.label}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ShiftStatistics;